// // ----------------------------------------------------------------------

// export function stepper(theme) {
//   return {
//     MuiStepConnector: {
//       styleOverrides: {
//         line: {
//           borderColor: theme.palette.divider,
//         },
//       },
//     },
//   };
// }

// ----------------------------------------------------------------------

export function stepper(theme) {
  return {
    MuiStepConnector: {
      styleOverrides: {
        line: {
          borderColor: theme.palette.divider,
          width: 2, // Adjust line thickness
        },
      },
    },
    MuiStepIcon: {
      styleOverrides: {
        root: {
          color: theme.palette.action.disabled, // Default icon color
          '&.Mui-completed': {
            color: theme.palette.success.main, // Icon color for completed steps
          },
          '&.Mui-active': {
            color: theme.palette.primary.main, // Icon color for active steps
            transform: 'scale(1.1)', // Slightly enlarge active step icon
            transition: 'transform 0.2s ease-in-out', // Smooth transition for scaling
          },
        },
      },
    },
    MuiStepLabel: {
      styleOverrides: {
        label: {
          fontSize: '0.675rem', // Font size for labels
          color: theme.palette.text.secondary,
          '&.Mui-active': {
            color: theme.palette.text.primary, // Color for active label
            fontWeight: theme.typography.fontWeightBold, // Bold font for active label
          },
          '&.Mui-completed': {
            color: theme.palette.text.primary, // Color for completed label
          },
        },
      },
    },
    MuiStepper: {
      styleOverrides: {
        root: {
          padding: theme.spacing(1), // Add spacing around the stepper
          paddingBottom: 0, // Remove padding from the bottom
          [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(1), // Reduce padding on smaller screens
            paddingBottom: 0, // Ensure no bottom padding on smaller screens
          },
        },
      },
    },
    MuiStep: {
      styleOverrides: {
        root: {
          '&:last-of-type': {
            [`& .MuiStepConnector-line`]: {
              display: 'none', // Hide the connector line after the last step
            },
          },
        },
      },
    },
  };
}

